module.exports = __webpack_public_path__ + "img/line_1.c98f475e.svg";